var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h3',[_vm._v("Querylogs dashboard")]),_c('ChiefsupervisorQuerylogsManagerWrapper',{attrs:{"baseHeaders":_vm.baseHeaders,"amlHeaders":_vm.amlHeaders,"workers":_vm.workers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }